import * as React from 'react';
import { Component } from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
  createSidebar,
  toggleSidebarCollapse,
  updateSidebar,
} from '../../redux/actions/general/sidebar';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import {
  __,
  dateFrom,
  getActiveStage,
  redirect,
} from '../../core/utils';
import Table from '../../components/Table';
import Avatar from '../../components/Avatar';
import TableNA from '../../components/TableNA';
import Tooltip from '../../components/Tooltip';
import styles from '../../styles/views/specifications/SpecificationSets.scss';
import { setPlusActions } from '../../redux/actions/general/plus';
import { listCurrentSetSpecificationSets } from '../../redux/actions/table/current_set_specification_sets';

const mapStateToProps = (state) => {
  return {
    table: state.table['current_set_specification_sets'],
    auth: state.auth,
  };
};

@connect(mapStateToProps)
class CurrentSetInteractiveSchedules extends Component {
  componentDidMount() {
    enableProjectsDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/specifications/current/sets')
    );
    enableStagesDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/specifications/current/sets')
    );

    setPlusActions([]);

    createSidebar({
      title: __('submenu.title.specifications'),
      items: [
        {
          title: __('submenu.title.current-set-specifications'),
          link: () =>
            '/stages/' +
            getActiveStage() +
            '/specifications/current?filter.subgroup=',
          active: true,
          expanded: true,
          onArrowClick: () => toggleSidebarCollapse('items.0'),
        },
        {
          title: __('submenu.title.working-set-specifications'),
          link: () => '/stages/' + getActiveStage() + '/specifications/working',
        },
        {
          title: __('submenu.title.specification-sets'),
          link: () => '/stages/' + getActiveStage() + '/specifications/sets',
        },
        {
          title: __('submenu.title.deliveries'),
          link: () =>
            '/stages/' + getActiveStage() + '/specification_deliveries',
        },
        {
          title: __('submenu.title.approvals'),
          link: () =>
            '/stages/' + getActiveStage() + '/specification_approvals',
        },
      ],
    });

    this._updateSidebarItems();
  }

  _updateSidebarItems() {
    updateSidebar('items.0.items', [
      {
        title: __('Specifications', {}, 'Specifications'),
        small_caps: true,
        expanded: true,
        onArrowClick: () => toggleSidebarCollapse('items.0.items.0'),
        items: [
          {
            title: __('submenu.title.current-set-specifications'),
            onClick: () =>
              redirect(
                '/stages/' +
                  getActiveStage() +
                  '/specifications/current?filter.subgroup='
              ),
          },
        ],
      },
      {
        title: __('Interactive schedules', {}, 'Interactive schedules'),
        small_caps: true,
        onClick: () =>
          redirect(
            '/stages/' + getActiveStage() + '/specifications/current/sets'
          ),
        active: true,
      },
    ]);
  }

  render() {
    const columns = [
      {
        key: 'identifier',
        name: __('table.columns.specification-set.code'),
        value: (value) => 'IS-' + value,
        width: 80,
        default: true,
        desc: true,
        required: true,
      },
      {
        key: 'title',
        name: __('table.columns.specification-set.title'),
        required: true,
        mobileVisible: true,
      },
      {
        key: 'administrators',
        name: __('table.columns.tender.administrators'),
        value: (administrator) => (
          <div className={styles.administrators}>
            {_.size(administrator) == 1 &&
              _.map(_.take(administrator, 1), (user, i) => (
                <Avatar
                  key={i}
                  avatar_url={user.avatar_url}
                  name={user.fullname}
                  active={user.active}
                />
              ))}
            {_.size(administrator) > 1 && (
              <Tooltip text={_.map(administrator, 'fullname').join('\n')}>
                <div className={styles.more}>
                  <span>{_.size(administrator)}</span>
                </div>
              </Tooltip>
            )}
          </div>
        ),
        sortable: false,
        width: 60,
        active: false,
      },
      {
        key: 'editors',
        name: __('table.columns.tender.editors'),
        value: (editor) => (
          <div className={styles.editors}>
            {_.size(editor) == 1 &&
              _.map(_.take(editor, 1), (user, i) => (
                <Avatar
                  key={i}
                  avatar_url={user.avatar_url}
                  name={user.fullname}
                  active={user.active}
                />
              ))}
            {_.size(editor) > 1 && (
              <Tooltip text={_.map(editor, 'fullname').join('\n')}>
                <div className={styles.more}>
                  <span>{_.size(editor)}</span>
                </div>
              </Tooltip>
            )}
          </div>
        ),
        sortable: false,
        width: 60,
        active: false,
      },
      {
        key: 'status',
        name: __('table.columns.specification-set.status'),
        value: (status) => {
          switch (status) {
            case 'draft':
              return (
                <Tooltip
                  text={__('table.columns.specification-set-status-draft')}
                >
                  <span className={classNames(styles.balloon, styles.draft)}>
                    {__('table.columns.specification-set-status-draft-short')}
                  </span>
                </Tooltip>
              );
            case 'active':
              return (
                <Tooltip
                  text={__('table.columns.specification-set-status-active')}
                >
                  <span className={classNames(styles.balloon, styles.active)}>
                    {__('table.columns.specification-set-status-active-short')}
                  </span>
                </Tooltip>
              );
            case 'finished':
              return (
                <Tooltip
                  text={__('table.columns.specification-set-status-finished')}
                >
                  <span className={classNames(styles.balloon, styles.finished)}>
                    {__(
                      'table.columns.specification-set-status-finished-short'
                    )}
                  </span>
                </Tooltip>
              );
            case 'closed':
              return (
                <Tooltip
                  text={__('table.columns.specification-set-status-closed')}
                >
                  <span className={classNames(styles.balloon, styles.closed)}>
                    {__('table.columns.specification-set-status-closed-short')}
                  </span>
                </Tooltip>
              );
            case 'canceled':
              return (
                <Tooltip
                  text={__('table.columns.specification-set-status-canceled')}
                >
                  <span className={classNames(styles.balloon, styles.canceled)}>
                    {__(
                      'table.columns.specification-set-status-canceled-short'
                    )}
                  </span>
                </Tooltip>
              );
          }
        },
        width: 50,
        default: true,
        fullWidth: true,
      },
      {
        key: 'visibility',
        name: __('table.columns.specification-set.visibility'),
        value: (visibility) =>
          visibility == '1' ? (
            <Tooltip
              text={__('table.columns.specification-set-visibility-public')}
            >
              <span className={classNames(styles.balloon, styles.public)}>
                {__('table.columns.specification-set-visibility-public-short')}
              </span>
            </Tooltip>
          ) : (
            <Tooltip
              text={__('table.columns.specification-set-visibility-private')}
            >
              <span className={classNames(styles.balloon, styles.private)}>
                {__('table.columns.specification-set-visibility-private-short')}
              </span>
            </Tooltip>
          ),
        width: 50,
      },
      {
        key: 'created_at',
        name: __('table.columns.specification-set.created_at'),
        value: (value) => (value ? dateFrom(value) : <TableNA />),
        width: 80,
        active: false,
      },
      {
        key: 'created_by',
        name: __('table.columns.specification-set.created-by'),
        value: (user) => (
          <Avatar
            avatar_url={user.avatar_url}
            name={user.fullname}
            active={user.active}
          />
        ),
        width: 50,
      },
    ];

    return (
      <Table
        listAction={() =>
          listCurrentSetSpecificationSets(this.props.match.params.stage)
        }
        name='current_set_specification_sets'
        title={__('Interactive schedules', {}, 'Interactive schedules')}
        columns={columns}
        onLoad={() => listActiveModules()}
        onRowClick={(id, row) => {
          redirect(row.url);
        }}
      />
    );
  }
}

export default CurrentSetInteractiveSchedules;
